"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PeriodFact;
(function (PeriodFact) {
    PeriodFact["PERIOD_STARTED"] = "PERIOD_STARTED";
    PeriodFact["PERIOD_FINISHED"] = "PERIOD_FINISHED";
})(PeriodFact = exports.PeriodFact || (exports.PeriodFact = {}));
var ClockFact;
(function (ClockFact) {
    ClockFact["CLOCK_STARTED"] = "CLOCK_STARTED";
    ClockFact["CLOCK_STOPPED"] = "CLOCK_STOPPED";
    ClockFact["CLOCK_ADJUSTED"] = "CLOCK_ADJUSTED";
})(ClockFact = exports.ClockFact || (exports.ClockFact = {}));
var SubstitutionFact;
(function (SubstitutionFact) {
    SubstitutionFact["SUBSTITUTION"] = "SUBSTITUTION";
})(SubstitutionFact = exports.SubstitutionFact || (exports.SubstitutionFact = {}));
var BreakFact;
(function (BreakFact) {
    BreakFact["PLAYERS_ENTERING"] = "PLAYERS_ENTERING";
    BreakFact["ABOUT_TO_START"] = "ABOUT_TO_START";
})(BreakFact = exports.BreakFact || (exports.BreakFact = {}));
exports.sharedFactNameMap = {
    SUBSTITUTION: 'substitution',
    CLOCK_STARTED: 'clock started',
    CLOCK_STOPPED: 'clock stopped',
    CLOCK_ADJUSTED: 'clock adjusted',
    PLAYERS_ENTERING: 'players entering',
    ABOUT_TO_START: 'about to start',
    PERIOD_STARTED: 'period started',
    PERIOD_FINISHED: 'period finished'
};
//# sourceMappingURL=Facts.js.map